import React from "react";
import { ErrorOutline as ErrorIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import EmptyState from "../../common/EmptyState";

interface ErrorDisplayProps {
	onRetry?: () => void;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ onRetry }) => {
	const { t } = useTranslation();

	return (
		<EmptyState
			icon={
				<ErrorIcon
					sx={{
						fontSize: 60,
						color: "white"
					}}
				/>
			}
			title={t("activityReports.loadingError")}
			message={t("activityReports.loadingErrorMessage")}
			iconBackgroundGradient="linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)"
			iconBoxShadow="0 10px 30px rgba(255, 107, 107, 0.3)"
			onRetry={onRetry}
			retryButtonText={t("activityReports.retryButton")}
		/>
	);
};

export default ErrorDisplay;
